import {pub, sub} from './pubsub.js'

function statusUpdate(newStatus) {
    pub("sessionStatusUpdate", newStatus)
}

function statusUpdateAddCallback(cb) {
    sub("sessionStatusUpdate", cb)
}

export default {
    basePath: "/sessions",
    statusUpdate,
    statusUpdateAddCallback,
}